var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.mainClass,attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"align":"center","cols":"12"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size}},[_c('v-img',{attrs:{"max-width":_vm.size - 20,"src":_vm.logo}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }